<template>
  <div class="users__points">
    <template v-if="isAdmin">
      <div class="main-block">
        <div class="table -users-points-table-">
          <div class="table__header">
            <div class="table__header-inner table__header-points">
              <Select
                title="Группы участников"
                placeholder="Выберите группы..."
                path="usersPoints"
              ></Select>
              <InputDate
                v-model="valueDate"
                class="table__header-points__date"
                title="Дата"
                range="range"
              ></InputDate>
            </div>
            <div v-if="isVisible" class="table__header-inner table__header-points">
              <Button @click="loadContent">Получить</Button>
              <template v-if="timeSpent">
                <Button @click="loadCSV">Скачать csv</Button>
                <p>Затраченное время: {{ timeSpent }}</p>
              </template>
            </div>
          </div>
          <Table
            v-if="isStartLoading"
            :is-loading="isLoading"
            :table-data="usersPointsData"
          ></Table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Select from './components/Select';
import Table from './components/Table';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    Select,
    Table
  },
  data() {
    return {
      selectedGroups: '',
      valueDate: [],
      objectRus: {
        fullName: 'Имя',
        city: 'Город',
        email: 'Email',
        groupName: 'Группа',
        points: 'Баллы'
      },
      isVisible: false,
      isTableVisible: false
    };
  },
  computed: {
    ...mapState('usersPoints', {
      isLoading: s => s.meta.isLoading,
      isStartLoading: s => s.meta.isStartLoading,
      usersPointsData: s => s.data.users,
      timeSpent: s => s.data.timeSpent,
      parameters: s => s.data.parameters,
      groupList: s => s.data.groupList
    }),
    ...mapState('auth', {
      user: s => s.data.user,
      isAdmin: s => s.data.user.permissions.isAdmin
    })
  },
  watch: {
    groupList(val) {
      if (val.length >= 1 && this.valueDate.length >= 1) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },
    valueDate(val) {
      if (val.length >= 1 && this.groupList.length >= 1) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    },
    usersPointsData() {
      this.isTableVisible = true;
    }
  },
  destroyed() {
    this.clearStoragePoints();
  },
  methods: {
    ...mapActions('usersPoints', ['loadUsersPoints', 'clearStoragePoints']),
    ...mapActions('usersGroups', ['getGroups']),
    loadContent() {
      this.loadUsersPoints(this.valueDate);
    },
    loadCSV() {
      let fileName;

      if (this.groupList.length >= 2) {
        fileName = `lms_points_groups_${this.groupList[0].name}...${
          this.groupList[this.groupList.length - 1].name
        }_${this.parameters.date1}_${this.parameters.date2}.csv`;
      } else {
        fileName = `lms_points_groups_${this.groupList[0].name}_${this.parameters.date1}_${this.parameters.date2}.csv`;
      }

      let str = Object.keys(this.usersPointsData[0]);
      str = str.map(el => this.objectRus[el]).join(';') + '\n';

      for (let i = 0; i < this.usersPointsData.length; i++) {
        const elem = this.usersPointsData[i];
        str += Object.values(elem).join(';') + '\n';
      }

      const data = encodeURI('data:text/csv;charset=utf-8,' + str);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', fileName);
      link.click();
      link.remove();
    }
  }
};
</script>
